export default __webpack_public_path__ + "static/media/mobNBACardBg.eceaaf1a.png";